import React from 'react'

const ChevronUp = props => {
  return (
    <svg width={20} height={12} viewBox="0 0 20 12" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.654l1.37 1.396 8.393-8.299.895.885-.005-.005 7.456 7.374L19.5 9.63 9.763 0C8.333 1.413 9.726.035 0 9.654z"
        fill="#304A3D"
      />
    </svg>
  )
}

export default ChevronUp
